import { useEffect, useRef, useState } from 'react';
import { AxiosInstance } from 'axios';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

import { MessageBubble } from './MessageBubble';
import { SendMessageSection } from './SendMessageSection';

import { IMessage } from '../../../../interfaces/entities';
import { ChatService } from '../../../../services/ChatService';

import { useMailStore } from '../store/mail.store';
import { useAuth } from '../../../../store/auth';

import { errorToast } from '../../../../utils/toasts';
import { errorMessageAdapter } from '../../../../adapters';
import { useApi } from '../../../../services/hooks/apiHook';

const MessengerBox: React.FC = () => {
  const [messages, setMessages] = useState<IMessage[]>([]);
  const { selectedUser, update } = useMailStore();
  const { user } = useAuth();
  const divRef = useRef<HTMLInputElement>(null);

  const scrollToBottom = () => {
    if (divRef.current) {
      divRef.current.scrollTop = divRef.current.scrollHeight;
    }
  };

  const { token } = useAuth();
  const { i18n } = useTranslation();

  const api: AxiosInstance = useApi();

  useEffect(() => {
    (async () => {
      try {
        const { messages } = await ChatService.listUserMessages(api, selectedUser!.id, {
          headers: { 'Content-Language': i18n.language.toLowerCase(), Authorization: `Bearer ${token}` }
        });

        setMessages(messages);
        scrollToBottom();
      } catch (e) {
        errorToast(errorMessageAdapter(e));
      }
    })();
  }, [selectedUser, update]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <>
      <div className="mb-4 flex flex-1 flex-col gap-4 overflow-auto px-4 py-4" ref={divRef}>
        {messages.map((message) => (
          <MessageBubble key={message.id} isMe={Number(message.from) === user?.id} message={message} />
        ))}
      </div>

      <SendMessageSection placeholder={t('labels.lblTypeHere') || ' '} />
    </>
  );
};

export { MessengerBox };
